import "pixi";
import "phaser";

import LevelState from "./level";
import * as progression from "../progression";
import * as i18n from "../i18n";
import * as logging from "../logging";
import BackButton from "../ui/back";
import MuteButton from "../ui/mute";
import AudioEngine from "../audio_engine";

export default class LevelSelectState extends Phaser.State {

    count: number;
    bg: Phaser.Sprite;
    select_level: Phaser.BitmapText | Phaser.Text;
    shrines: Array<Shrine>;
    reset_button: Phaser.BitmapText | Phaser.Text;
    back: BackButton;
    mute: MuteButton;
    triTween: Phaser.Tween;

    tmap: TweenMap;

    isRestart: boolean;

    init(isRestart=false) {
        this.isRestart = isRestart;
    }

    create() {
        this.count = 0;
        this.game.stage.backgroundColor = "#FFFFFF";

        this.bg = this.game.add.sprite(0, 0, "background2");
        this.bg.width = this.game.width;
        this.bg.height = this.game.height;
        this.bg.alpha = 0;

        this.select_level = i18n.label(this.game, 400, 20, i18n._("SELECT LEVEL"), "font-small", 32);
        this.select_level.anchor.setTo(0.5, 0.5);
        this.select_level.alpha = 0;

        this.back = new BackButton(this.game, () => { this.title(); });
        this.back.alpha = 0;

        this.shrines = [];
        var i:number = 0;
        let levelData = [];

        let levelJSON = localStorage.getItem("levels");
        if(levelJSON == null){
            this.reset_levels();
            levelJSON = localStorage.getItem("levels");
            if(levelJSON != null){
                levelData = JSON.parse(levelJSON);
            }
        }
        else {
            levelData = JSON.parse(levelJSON);
        }



        // TODO: only show levels you've gotten to as locked
        for(i=0; i<20; i+=1){
            this.shrines[i] = new Shrine(i+1, progression.LEVELS[i], levelData[i], this.game);
        }

        this.reset_button = i18n.label(this.game, 796, 596, i18n._("RESET"), "font-small", 24);
        this.reset_button.anchor.setTo(1,1);
        this.reset_button.alpha = 0;

        this.tmap = {};

        this.tmap['backgroundFadeIn'] =  this.game.add.tween(this.bg).to( { alpha: 1 }, 150, "Linear");
        this.tmap['selectLevelFadeIn'] = this.game.add.tween(this.select_level).to( { y: 40, alpha: 1 }, 250, Phaser.Easing.Linear.None);
        this.tmap['backgroundFadeIn'].chain(this.tmap['selectLevelFadeIn']);

        for(i=0; i<20; i+=1){
            this.shrines[i].makeTween(this.tmap['selectLevelFadeIn']);
        }
        this.tmap['resetFadeIn'] = this.game.add.tween(this.reset_button).to( { alpha: 1 }, 250, Phaser.Easing.Cubic.InOut, false, 800);
        this.tmap['backFadeIn'] = this.game.add.tween(this.back).to( { alpha: 1 }, 250, Phaser.Easing.Cubic.InOut, false, 800);

        this.tmap['selectLevelFadeIn'].onComplete.add(() => {
            this.tmap['resetFadeIn'].start();
            this.tmap['backFadeIn'].start();
        });

        this.tmap['resetFadeIn'].onComplete.add(() => {
            let i:number = 0;
            for(i=0; i<20; i+=1){
                this.shrines[i].enable();
            }
            this.reset_button.inputEnabled = true;
            this.reset_button.input.useHandCursor = true;
            this.reset_button.events.onInputDown.add(this.reset_levels, this);

            this.back.enable();
        });

        this.tmap['backgroundFadeIn'].start();

        if (!this.isRestart) logging.startLevel(logging.LEVEL_SELECT, null);

        this.mute = new MuteButton(this.game, () =>{
            AudioEngine.get().mute();
        },
        () => {
            AudioEngine.get().unmute();
        }, 1600);
    }

    reset_levels(){
        let levelData = [];
        for(let i=0; i<20; i+=1) {
            let locked = true;
            if(!logging.PRODUCTION){
                locked = (i >= progression.LEVELS.length);
            }
            levelData[i] = {locked: locked, par:100};
        }
        levelData[0] = {locked: false, par:100};
        localStorage.setItem("levels", JSON.stringify(levelData));
        logging.logAction(logging.Action.ResetLevels);
        this.game.state.restart(true, false, true);
    }

    title(){
        logging.finishLevel();
        this.game.state.start("title", true, false, true);
    }

    render() {
    }

    reset() {
    }

    update() {
        if (!logging.PRODUCTION && this.game.input.keyboard.isDown(Phaser.KeyCode.SPACEBAR)) {
            // TODO: start the level we were most recently on
            logging.finishLevel();
            LevelState.startWithLevelName(this.state, progression.LEVELS[0]);
        }
    }

}

class Shrine {
    num: number;
    filename: string;
    locked: boolean;
    par: number;
    hover: boolean;
    shrine_sprite: Phaser.Sprite;
    lock_sprite: Phaser.Sprite;
    play_sprite: Phaser.Sprite;
    num_text: Phaser.BitmapText;
    game: Phaser.Game;
    playTween: Phaser.Tween;
    numTween: Phaser.Tween;

    constructor(num: number, filename: string, levelData: {locked: boolean, par:number}, game: Phaser.Game){
        this.num = num;
        this.filename = filename;
        this.locked = levelData.locked;
        this.par = levelData.par;
        this.game = game;
        this.hover = false;

        let x = (num-1) % 5;
        let y = Math.floor((num-1) / 5);
        if(this.par <= 0){
            this.shrine_sprite = this.game.add.sprite(x*150+60, y*130+60, "shrine-star");
        }
        else {
            this.shrine_sprite = this.game.add.sprite(x*150+60, y*130+80, "shrine");
        }

        this.shrine_sprite.alpha = 0;

        if(!this.locked){
            this.num_text = this.game.add.bitmapText(x*150+100,y*130+118,"number-font",String(num),24);
            this.num_text.anchor.setTo(0.5, 0.5);
            this.num_text.alpha = 0;

            this.play_sprite = this.game.add.sprite(x*150+101,y*130+128,'play');
            this.play_sprite.anchor.setTo(0.5, 0.5);
            this.play_sprite.alpha = 0;
        }
        else {
            this.lock_sprite = this.game.add.sprite(x*150+100,y*130+118,'lock');
            this.lock_sprite.anchor.setTo(0.5, 0.5);
            this.lock_sprite.alpha = 0;
        }
    }

    makeTween(fromTween: Phaser.Tween){
        let y = Math.floor((this.num-1) / 5);
        let toTween = this.game.add.tween(this.shrine_sprite).to( { y: 90+y*130, alpha: 1 }, 800-y*200, Phaser.Easing.Linear.None, true, y*200+1100);
        if(this.par <= 0){
            toTween = this.game.add.tween(this.shrine_sprite).to( { y: 70+y*130, alpha: 1 }, 800-y*200, Phaser.Easing.Linear.None, true, y*200+1100);
        }
        fromTween.chain(toTween);
        if(!this.locked){
            let toTween = this.game.add.tween(this.num_text).to( { y: 128+y*130, alpha: 1 }, 800-y*200, Phaser.Easing.Linear.None, true, y*200+1100);
            fromTween.chain(toTween);
        }
        else {
            let toTween = this.game.add.tween(this.lock_sprite).to( { y: 128+y*130, alpha: 1 }, 800-y*200, Phaser.Easing.Linear.None, true, y*150+1100);
            fromTween.chain(toTween);
        }
    }

    enable(){
        if(!this.locked){
            this.shrine_sprite.inputEnabled = true;
            this.shrine_sprite.input.useHandCursor = true;
            this.shrine_sprite.events.onInputOver.add(this.hoverIn, this);
            this.shrine_sprite.events.onInputOut.add(this.hoverOut, this);
            this.shrine_sprite.events.onInputDown.add(this.play, this);
        }
    }

    hoverIn(){
        if(!this.locked){
            if(this.playTween != null){
                this.playTween.stop();
                this.numTween.stop();
            }
            this.playTween = this.game.add.tween(this.play_sprite).to( { alpha: 1 }, 60, "Linear", true);
            this.numTween = this.game.add.tween(this.num_text).to( { alpha: 0 }, 60, "Linear", true);
        }

    }

    hoverOut(){
        if(!this.locked){
            if(this.playTween != null){
                this.playTween.stop();
                this.numTween.stop();
            }
            this.playTween = this.game.add.tween(this.play_sprite).to( { alpha: 0 }, 60, "Linear", true);
            this.numTween = this.game.add.tween(this.num_text).to( { alpha: 1 }, 60, "Linear", true);
        }
    }

    play() {
        logging.finishLevel();
        LevelState.startWithLevelName(this.game.state, this.filename);
    }
}

interface TweenMap {
    [key: string]: Phaser.Tween;
}



// WEBPACK FOOTER //
// ./src/states/level_select.ts